import React from 'react';
import './index.scss';

const Header = () => {
  return (
    <header>
      <h1 className="site-title">forecastr</h1>
      <nav>
        <ul>
          <li>Nav Item</li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
